export default "/_next/static/chunks/fonts/Syne ExtraBold-99cf775aa2fb7d59d2da294c5214a4ff.ttf";